export default [
  { id: 'date', label: 'Date' },
  { id: 'height', label: 'Height' },
  { id: 'weight', label: 'Weight' },
  { id: 'waist', label: 'Waist' },
  { id: 'arms', label: 'Upper Arms' },
  { id: 'chest', label: 'Chest' },
];
